import { CalendarEvent } from "angular-calendar";
import { User } from "../models";
import { ApiService } from "../services";

export abstract class CalendarAdapter
{
    public Calendar_View_Month = "CalendarView.Month";
    public Calendar_View_Week = "CalendarView.Week";
    public Calendar_View_Day = "CalendarView.Day";

    constructor(
        calendarUser: User,
        teamScope: boolean,
    ) {
        this.calendarUser = calendarUser;
        this.teamScope = teamScope;
    }

    public monthToolTipPlacement:string = "right";
    public dayEventWidth:number = 300;
    public calendarUser: User;
    public teamScope: boolean = false;

    // public calendarFilter0: any[];
    // public calendarFilter1: any[];
    // public calendarFilter2: any[];

    public abstract getEvents(params:any):CalendarEvent[];

    public abstract handleEvent(action: string, event: CalendarEvent):void;

    public abstract getCalendarTitle(view:string, date:Date): string;

    public getDateStartHour() { return 9; }
    public getDateEndHour() { return 5; }
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/adapters/calendar.adapter.ts